import React, { forwardRef } from "react";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import "./button.css";

const Button = forwardRef((props, ref) => {
  const {
    id,
    name,
    type,
    disabled,
    className,
    onClick,
    onMouseEnter,
    onMouseLeave,
    onKeyDown,
    onKeyUp,
    onFocus,
    onBlur,
    onContextMenu,
    content,
    place,
    style,
    label,
  } = props;

  return (
    <> 
      <Tooltip anchorId={id} content={content} place={place} style={{fontSize: 13, maxWidth: 160}} />
      {/* hiden */}
      <button
        id={id}
        name={name}
        type={type}
        disabled={disabled}
        className={`buttonE ${className}`}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        onFocus={onFocus}
        onBlur={onBlur}
        onContextMenu={onContextMenu}
        style={{ ...style }}
      >
        <span>{label}</span>
      </button>
    </>
  );
});

//max-lg:w-[50px] mirar.
export default Button;
